import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { PdfPopoverPage } from './pdf-popover';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
  declarations: [
    PdfPopoverPage,
  ],
  exports: [
    PdfPopoverPage,
  ],
})
export class PdfPopoverPageModule {}
